import { Component, Input } from '@angular/core';
import { Icp } from '../../utils/icp.util';
import { BrandCopy, getBrandCopy } from './brand-copy';

/**
 * Dark brand panel shared by the login and signup pages.
 * `login` stays text-only; `signup` adds the first-week plan, a customer quote and a product screen.
 */
@Component({
  selector: 'app-auth-brand-panel',
  templateUrl: './auth-brand-panel.component.html',
  styleUrls: ['./auth-brand-panel.component.css'],
  standalone: false
})
export class AuthBrandPanelComponent {
  @Input() variant: 'login' | 'signup' = 'login';
  @Input() icp: Icp = 'default';

  get copy(): BrandCopy {
    return getBrandCopy(this.icp);
  }

  get visualSrc(): string {
    return this.icp === 'agency'
      ? 'assets/images/Work_Replay_UI-2-opt.webp'
      : 'assets/images/SuperSee-dashboard-with-status-and-timeline-2-opt.webp';
  }

  get visualAlt(): string {
    return this.icp === 'agency'
      ? 'SuperSee Work Replay for one person on one day'
      : 'SuperSee team dashboard with status and workday timeline';
  }
}
